var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntelligentAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48.948 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4636",
    "data-name": "Group 4636",
    transform: "translate(-0.275 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4635",
    "data-name": "Group 4635",
    transform: "translate(0.275 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5996",
    "data-name": "Path 5996",
    d: "M235.406,387.013h-3.268a.718.718,0,1,0,0,1.436h3.268a.718.718,0,1,0,0-1.436Z",
    transform: "translate(-209.298 -349.973)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5997",
    "data-name": "Path 5997",
    d: "M46.081,6.892H30.471L27.364,1.51a3.019,3.019,0,0,0-5.229,0l-.7,1.205a.718.718,0,0,0,1.243.718l.7-1.205a1.584,1.584,0,0,1,2.743,0L39.026,24.581a1.583,1.583,0,0,1-1.371,2.375H11.843a1.583,1.583,0,0,1-1.371-2.375L21.029,6.295a.718.718,0,0,0-1.243-.718l-.759,1.315H3.417A3.145,3.145,0,0,0,.275,10.034V38.414a3.145,3.145,0,0,0,3.142,3.141H19.378a37.651,37.651,0,0,1-.585,6.009H16.306a.718.718,0,1,0,0,1.436H33.192a.718.718,0,1,0,0-1.436H30.7a37.678,37.678,0,0,1-.585-6.009H46.081a3.145,3.145,0,0,0,3.141-3.141V10.034A3.145,3.145,0,0,0,46.081,6.892ZM1.711,10.034A1.708,1.708,0,0,1,3.417,8.328H18.2l-1.072,1.857H5.045a1.78,1.78,0,0,0-1.778,1.778v22H1.711ZM20.262,47.564a42.18,42.18,0,0,0,.552-6.009h7.869a42.178,42.178,0,0,0,.552,6.009Zm27.524-9.15a1.708,1.708,0,0,1-1.706,1.706H3.417a1.708,1.708,0,0,1-1.706-1.706V35.4H32.625a.718.718,0,1,0,0-1.436H4.7v-22a.342.342,0,0,1,.342-.342H16.3L9.229,23.863a3.019,3.019,0,0,0,2.615,4.529H37.654a3.019,3.019,0,0,0,2.615-4.529L33.2,11.62H44.452a.342.342,0,0,1,.342.342v22H36.06a.718.718,0,1,0,0,1.436H47.787Zm0-4.455H46.23v-22a1.78,1.78,0,0,0-1.778-1.778H32.372L31.3,8.328H46.081a1.708,1.708,0,0,1,1.706,1.706V33.959Z",
    transform: "translate(-0.275 0)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5998",
    "data-name": "Path 5998",
    d: "M232.443,214.335a2.492,2.492,0,1,0-2.492-2.492A2.5,2.5,0,0,0,232.443,214.335Zm0-3.549a1.057,1.057,0,1,1-1.057,1.057A1.058,1.058,0,0,1,232.443,210.786Z",
    transform: "translate(-207.969 -189.314)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5999",
    "data-name": "Path 5999",
    d: "M234.036,79.064a2.344,2.344,0,0,0,2.341-2.341v-7.75a2.341,2.341,0,1,0-4.682,0v7.75A2.344,2.344,0,0,0,234.036,79.064Zm-.905-10.091a.905.905,0,0,1,1.811,0v7.75a.905.905,0,0,1-1.811,0Z",
    transform: "translate(-209.547 -60.255)",
    fill: "#f48116"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentAlerts);
export default __webpack_public_path__ + "static/media/IntelligentAlerts.117d701d5bb4ad476ee5c5bb372b5d6e.svg";
export { ForwardRef as ReactComponent };